import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CustomValidators } from "../../validators/CustomValidators.validator";

@Component({
    selector: "app-login-modal",
    templateUrl: "./login-modal.component.html",
    styleUrls: ["./login-modal.component.scss"]
})
export class LoginModalComponent implements OnInit {
    @Output() loggedIn: EventEmitter<void> = new EventEmitter<void>();

    public form!: FormGroup;

    constructor(public fb: FormBuilder) {}

    ngOnInit(): void {
        this.form = this.initLoginForm();
    }

    private initLoginForm() {
        return this.fb.group(
            {
                user: this.fb.control("", [Validators.required, CustomValidators.user]),
                password: this.fb.control("", [Validators.required, CustomValidators.password])
            },
            { updateOn: "submit" }
        );
    }

    public submitForm(valid: boolean) {
        if (valid) {
            this.loggedIn.emit();
        } else {
            console.error("Sorry, your input is either invalid or incorrect");
        }
    }
}
